import React, { Component } from 'react';
import { connect } from 'react-redux';
import CalYearPerfRow from './CalYearPerfRow';
import './PerformanceTable.css';
import i18n from '../../../i18n';

class CalYearPerfTable extends Component {

  // create the rows
  renderRows() {
    const {
      data
    } = this.props;

    return data.map((fund) => {
      return (
        <CalYearPerfRow key={fund.externalID} fund={fund} />
      );
    });
  }

  // create the header
  renderHeader() {
    const {
      data
    } = this.props;


    const hasData = data.filter((e) => e.calYearPerformance);
    const asOfDate = new Date(hasData[0].calYearPerformance.date).toLocaleDateString();
    const my_years = hasData[0].calYearPerformance.keys;
    const n = my_years[0] === 'YTD' ? new Date(hasData[0].calYearPerformance.date).getFullYear() : my_years[0];
    const fill_cnt = 12 - my_years.length;
    for (let i = 1; i <= fill_cnt; i++) {
      my_years.unshift(n - i);
    }

    const columns = my_years.map((value, idx) => {
      return (
        <th key={idx} className='textCenter'>{value}</th>
      );
    });

    return (
      <thead>
        <tr>
          <th colSpan='3' scope='col group' className='textLeft'>CALENDAR YEAR PERFORMANCE<br />{i18n.t('as of')} {asOfDate}</th>
          <th colSpan='12' scope='colgroup' className='borderleft borderbottom textCenter'>
            {i18n.t('Average Annual Calendar Year Returns')}
          </th>
        </tr>
        <tr>
          <th scope='col' className='textLeft'>{i18n.t('Ticker')}</th>
          <th scope='col' className='textLeft hidden-xs'>{i18n.t('Fund')}</th>
          <th scope='col' className='borderRight .textCenter'>{i18n.t('Inception')}<br /> {i18n.t('Date')}</th>
          {columns}

        </tr>

      </thead>
    );
  }

  render() {
    const {
      data
    } = this.props;

    const hasData = data.filter((e) => e.calYearPerformance);
    if (hasData.length > 0) {
      return (
        <div>
          {/* <div className={s.heading}>{i18n.t('Calendar Year Performance')}</div> */}
          <div className='table-responsive'>
            <table className='table tableFC'>
              {this.renderHeader()}
              <tbody>{this.renderRows()}</tbody>
            </table>
          </div>
        </div>
      );
    } else {
      return null;
    }
  }
}

function mapStateToProps(state) {
  return {
    data: state.fundData.data,
  };
}
export default connect(mapStateToProps, {})(CalYearPerfTable);
